import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "./ui/dialog";
import { cn } from "@/lib/utils";

const ImageLightbox = ({ src, alt, children, className }) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className={cn("text-left w-full focus:outline-none focus:ring-2 focus:ring-cyan-500 rounded-lg overflow-hidden cursor-zoom-in", className)}>
          {children}
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-[95vw] max-h-[95vh] p-0 border-none bg-transparent shadow-none focus:outline-none">
        <div className="relative w-full h-full flex items-center justify-center p-4 cursor-zoom-out">
          <DialogTrigger asChild>
            <img
              src={src}
              alt={alt}
              className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
            />
          </DialogTrigger>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImageLightbox;
